import React from 'react';
import { Youtube, Video, FileText, Presentation, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Materials = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const materials = [
    {
      title: 'AI to hack the Universe',
      type: 'Youtube',
      thumbnail: 'https://images.unsplash.com/photo-1614730321146-b6fa6a46bcb4?auto=format&fit=crop&q=80&w=400',
      icon: Youtube,
      link: 'https://www.youtube.com/watch?v=6Z4OCrYY6lw',
      date: '2019'
    },
    {
      title: 'Mitos y verdades del futuro de la inteligencia artificial',
      type: 'Youtube',
      thumbnail: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&q=80&w=400',
      icon: Youtube,
      link: 'https://youtu.be/vSrLiyyz2i8',
      date: '2024'
    },
   //
   // {
   //   title: 'Introducción a ChatGPT',
   //   type: 'Video',
   //   thumbnail: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&q=80&w=400',
   //   icon: Video,
   //   link: 'https://youtube.com/watch?v=example2',
   //   date: '2023'
   // },
   // {
   //   title: 'Guía Práctica de Prompting',
   //   type: 'Documento',
   //   thumbnail: 'https://images.unsplash.com/photo-1664447972779-316251bd8bd7?auto=format&fit=crop&q=80&w=400',
   //   icon: FileText,
    //  link: 'https://example.com/guide.pdf',
   //   date: '2023'
   // }
  ];

  return (
    <section id="materials" className="py-20 bg-gradient-to-br from-cyan-50 via-white to-purple-50">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-center mb-4 bg-gradient-to-r from-cyan-500 to-purple-600 bg-clip-text text-transparent">
          {t.materials.title}
        </h2>
        <p className="text-center text-gray-600 mb-12">
          {t.materials.subtitle}
        </p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {materials.map((item, index) => (
            <a
              key={index}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative overflow-hidden rounded-xl bg-white shadow-md hover:shadow-xl transition-all duration-300"
            >
              <div className="aspect-video w-full overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white transform translate-y-0 group-hover:translate-y-0 transition-transform">
                <div className="flex items-center gap-2 mb-2">
                  <item.icon className="w-5 h-5" />
                  <span className="text-sm font-medium">{item.type}</span>
                </div>
                <h3 className="text-lg font-semibold mb-1">{item.title}</h3>
                <p className="text-sm opacity-90">{item.date}</p>
              </div>
            </a>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Materials;